// @flow
import React, { useState } from 'react';
import classNames from 'classnames';
import { ListFilterItem } from 'components/atoms/listFilterItem';
import { useViewport } from 'components/templates/viewportProvider';
import type { LocationOption } from 'types/filter';
// eslint-ignore-next-line
import styles from './styles.scss';

type Props = {
  activeFilters: Array<number>,
  toggleFilter: (option: any) => void,
  options: Array<LocationOption>,
};

export const LocationFilter = (props: Props) => {
  const { isMobile } = useViewport();
  if (isMobile) {
    return <LocationFilterMobile {...props} />;
  }

  const { options, activeFilters = [], toggleFilter } = props;

  return (
    <div className={'location-filter'}>
      {options.map(option => {
        return (
          <div className={'filter'} key={option.country}>
            <div className={'filter-title'}>{option.country}</div>
            <div className={'filter-options'}>
              {option.cities.map(city => {
                return (
                  <ListFilterItem
                    title={city.name}
                    isActive={activeFilters.indexOf(city.id) > -1}
                    onClick={() => toggleFilter(city)}
                    key={city.id}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const LocationFilterMobile = (props: Props) => {
  const [activeCountry, setActiveCountry] = useState(0);

  const { options, activeFilters = [], toggleFilter } = props;

  const hasActiveFilters = (countryName: string): boolean => {
    let hasFilters = false;
    options
      .filter(option => option.country === countryName)
      .forEach(option => {
        option.cities.forEach(city => {
          if (activeFilters.indexOf(city.id) > -1) {
            hasFilters = true;
          }
        });
      });

    return hasFilters;
  };

  return (
    <div className={'location-filter'}>
      <div className={'filter'}>
        <div className={'filter-tabs'}>
          {options.map((option, idx) => {
            const titleClassNames = classNames('filter-title', {
              active: idx === activeCountry,
              selected: hasActiveFilters(option.country),
            });
            return (
              <div
                key={option.country}
                className={titleClassNames}
                onClick={() => setActiveCountry(idx)}
              >
                {option.country}
              </div>
            );
          })}
        </div>
        {options
          .filter((option, idx) => idx === activeCountry)
          .map(option => {
            return (
              <div className={'filter-options'} key={option.country}>
                {option.cities.map(city => {
                  return (
                    <ListFilterItem
                      title={city.name}
                      isActive={activeFilters.indexOf(city.id) > -1}
                      onClick={() => toggleFilter(city)}
                      key={city.id}
                    />
                  );
                })}
              </div>
            );
          })}
      </div>
    </div>
  );
};
